// extracted by mini-css-extract-plugin
export default {"container":"approval-sign_modal_container__F3SZ2","image-container":"approval-sign_modal_image-container__PuSMK"};